// 현재 역할 라우트만 루트로 승격해 라우터를 만들고, 인증 가드와 문서 제목을 설정한다
import { createRouter, createWebHistory } from 'vue-router'
import generated from '~pages'
import type { SiteKey } from './site'
import { selectSiteRoutes } from './routing'
import { useAppStore } from '@/stores'

// 토큰 없이도 접근 가능한 공개 경로(로그인·비밀번호 재설정·hq SSO 진입)
const PUBLIC_PATHS = new Set(['/login', '/reset-request', '/reset', '/connectionHQ', '/terms', '/privacy'])

export function createAppRouter(site: SiteKey) {
  const routes = selectSiteRoutes(generated, site)

  const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
  })

  // 인증 가드. 공개 경로가 아니고 토큰이 없으면 로그인으로 보낸다(AT 만료 재발급은 api.ts 인터셉터 담당)
  router.beforeEach(to => {
    if (!PUBLIC_PATHS.has(to.path) && !useAppStore().hasAuth) {
      return { path: '/login' }
    }
    return true
  })

  // 라우트 meta.title을 문서 제목에 반영
  router.afterEach(to => {
    const base = import.meta.env.VITE_APP_TITLE || '경기청년 사다리 프로그램'
    document.title = to.meta.title ? `${String(to.meta.title)} - ${base}` : base
  })

  return router
}
